function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.222 5.333h5.334a.889.889 0 000-1.777H6.222a.889.889 0 100 1.777zM4.444 8.89h7.112a.889.889 0 000-1.778H4.444a.889.889 0 000 1.778zm0 3.555h7.112a.889.889 0 000-1.777H4.444a.889.889 0 000 1.777zM15.111 0H.89A.889.889 0 000 .889v16a.889.889 0 001.422.711l1.84-1.378L5.093 17.6a.889.889 0 001.067 0L8 16.222 9.84 17.6a.889.889 0 001.067 0l1.83-1.378 1.84 1.378A.889.889 0 0016 16.889v-16A.889.889 0 0015.111 0zm-.889 15.111l-.95-.711a.889.889 0 00-1.068 0l-1.83 1.378-1.84-1.378a.889.889 0 00-1.067 0l-1.84 1.378L3.796 14.4a.889.889 0 00-1.067 0l-.951.711V1.778h12.444V15.11z",
  fill: "currentColor",
  fillRule: "evenodd"
})));